module.exports = __webpack_public_path__ + "img/style-1.53c1b673.png";